import { render, staticRenderFns } from "./PrintPage.vue?vue&type=template&id=0fa043bc&scoped=true&"
import script from "./PrintPage.vue?vue&type=script&lang=js&"
export * from "./PrintPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa043bc",
  null
  
)

export default component.exports